import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { environment } from "@orderna/admin-panel/src/environments/environment";
import { firstValueFrom } from "rxjs";
import { SuccessResponse } from "../shared/success-response";
import { FindLastIneligiblePaymentPlanResponseDto } from "./dtos/find-last-ineligible-payment-plan.response.dto";
import { FindActivePaymentPlanResponseDto } from "./dtos/find-active-payment-plan.response.dto";

@Injectable({
  providedIn: 'root',
})
export class PaymentPlansApiService {
  private readonly API = `${environment.api}/payment-plans`;
  #http = inject(HttpClient);

  async findActivePaymentPlan() {
    const result = await firstValueFrom(
      this.#http.get<SuccessResponse<FindActivePaymentPlanResponseDto>>(
        `${this.API}/active`,
      )
    );
    
    return result.data;
  }

  async findLastIneligiblePaymentPlan() {
    const result = await firstValueFrom(
      this.#http.get<SuccessResponse<FindLastIneligiblePaymentPlanResponseDto>>(
        `${this.API}/last-ineligible`,
      )
    );
    
    return result.data;
  }
}